/**
 * 电子档案室 模块接口列表
 */
import {backendUrl} from '@/assets/js/config'
import axios from '@/assets/plugins/axios'
import queryString from 'querystring'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}

export default {
  // 1. 设置审核任务 获取人员列表
  getMembersConfigTask (params) {
    return axios.get(`${backendUrl}/enterprise/database/permission`, params)
  },
  // 1.1 设置审核任务 "确认" 保存数据
  setTask (query, params) {
    return axios.patchArr(`${backendUrl}/enterprise/database/permission?` + queryString.stringify(query), params)
  },
  // 2. 设置免审核人员时 获取人员列表
  getMembersSetPrivilege (params) {
    return axios.get(`${backendUrl}/enterprise/database/inspect`, params)
  },
  // 2.1 设置免审核权限
  setPrivilege (query, params) {
    return axios.patch(`${backendUrl}/enterprise/database/inspect?` + queryString.stringify(query), params, headers)
  }
}
